export const dateFormat = 'DD/MM/YYYY'

export const formatDate = (date: string | undefined) =>
	date ? new Date(date).toLocaleString('en-GB') : ''

export const getDateGeneralFormat = (date: string) => {
	const typedDate = new Date(date)
	const day = typedDate.getDate()
	const month = typedDate.getMonth() + 1
	const year = typedDate.getFullYear()
	return `${day.toString().padStart(2, '0')}/${month
		.toString()
		.padStart(2, '0')}/${year}`
}

export const getMonthAndYear = (date: string) => {
	let mappedDate = new Date(date).toDateString().slice(4)
	mappedDate = `${mappedDate.slice(0, 3)} ${mappedDate.slice(-4)}`
	return mappedDate
}

const ISO_CALENDAR_DATE = /^(\d{4})-(\d{2})-(\d{2})/

// Stored as UTC midnight, so parsing these as local instants lands a day early west of UTC.
export const parseCalendarDate = (date: string): Date | undefined => {
	const parts = ISO_CALENDAR_DATE.exec(date)
	if (!parts) {
		return undefined
	}
	const year = Number(parts[1])
	const monthIndex = Number(parts[2]) - 1
	const day = Number(parts[3])
	const parsed = new Date(year, monthIndex, day)
	const isRealCalendarDay =
		parsed.getFullYear() === year &&
		parsed.getMonth() === monthIndex &&
		parsed.getDate() === day
	return isRealCalendarDay ? parsed : undefined
}

export const formatCalendarDate = (date: string): string => {
	const parsed = parseCalendarDate(date)
	if (!parsed) {
		return ''
	}
	const day = parsed.getDate().toString().padStart(2, '0')
	const month = (parsed.getMonth() + 1).toString().padStart(2, '0')
	return `${day}/${month}/${parsed.getFullYear()}`
}

export const convertDateToIsoString = (
	date: Date | null | undefined | string
) => {
	if (!date) {
		return undefined
	}
	if (typeof date === 'string') {
		return date
	}
	const dateTimestamp = date.getTime()
	if (Number.isNaN(dateTimestamp)) {
		return undefined
	}
	// Use local date components to construct a UTC midnight timestamp, so the
	// intended calendar day is preserved regardless of the user's timezone.
	return (
		new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))
			.toISOString()
			// Removes the microseconds as the server expects only seconds.
			.replace(/\.\d*Z$/, 'Z')
	)
}

export const addYearsToIsoDate = (isoDate: string, years: number): string => {
	const date = new Date(isoDate)
	return new Date(
		Date.UTC(
			date.getUTCFullYear() + years,
			date.getUTCMonth(),
			date.getUTCDate()
		)
	)
		.toISOString()
		.replace(/\.\d*Z$/, 'Z')
}

// Helper function to create year array from startYear to endYear (inclusive)
export const createYearArray = (
	endYear: number,
	startYear = 2010
): number[] => {
	const length = endYear - startYear + 1
	return Array.from({ length }, (_, index) => endYear - index)
}
